import React from "react";
import { motion } from "framer-motion";
import { Camera, Scan, Plus, Target } from "lucide-react";
import { useNavigate } from "react-router-dom";

const QuickActions = () => {
  const navigate = useNavigate();

  const actions = [
    {
      icon: Camera,
      label: "Snap",
      gradient: "from-emerald-500/20 to-teal-500/20",
      iconColor: "text-emerald-600",
      onClick: () => navigate("/scan"),
    },
    
    {
      icon: Target,
      label: "Set Goal",
      gradient: "from-purple-500/20 to-pink-500/20",
      iconColor: "text-purple-600",
      onClick: () => navigate("/set-goal"),
    },
  ];
{/*{
      icon: Scan,
      label: "Barcode Scan",
      gradient: "from-blue-500/20 to-indigo-500/20",
      iconColor: "text-blue-600",
      onClick: () => navigate("/barcode"),
    },
    {
      icon: Plus,
      label: "Quick Add",
      gradient: "from-orange-500/20 to-rose-500/20",
      iconColor: "text-orange-600",
      onClick: () => navigate("/quick-add"),
    }, */}


  return (
    <div className="grid grid-cols-2 gap-3 w-full">
      {actions.map((action, index) => {
        const Icon = action.icon;

        return (
          <motion.button
            key={index}
            onClick={action.onClick}
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.08 }}
            whileHover={{ scale: 1.04 }}
            whileTap={{ scale: 0.96 }}
            className="
              relative bg-white border border-gray-200
              rounded-xl shadow-sm hover:shadow
              py-3 px-2
              flex flex-col items-center justify-center
              transition-all
            "
          >
            {/* Gradient Background */}
            <div
              className={`absolute inset-0 bg-gradient-to-br ${action.gradient} opacity-60`}
            />

            <div className="absolute inset-0 backdrop-blur-[1px]" />

            {/* Icon (UNCHANGED) */}
            <div className="relative z-10 mb-1">
              <Icon className={`w-7 h-7 ${action.iconColor}`} />
            </div>

            {/* Label */}
            <p className="text-xs font-medium text-gray-700 relative z-10 text-center leading-tight">
              {action.label}
            </p>
          </motion.button>
        );
      })}
    </div>
  );
};

export default QuickActions;
